import { render, staticRenderFns } from "./TreatmentRecipeModal.vue?vue&type=template&id=733bc11e&scoped=true"
import script from "./TreatmentRecipeModal.vue?vue&type=script&lang=ts"
export * from "./TreatmentRecipeModal.vue?vue&type=script&lang=ts"
import style0 from "./TreatmentRecipeModal.vue?vue&type=style&index=0&id=733bc11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733bc11e",
  null
  
)

export default component.exports